import { useState } from 'react';
import { Image as ImageIcon, Trash2 } from 'lucide-react';
import { apiCall } from './useAutoSave';
import MediaPickerModal from '../MediaPickerModal';
import NahratMedia from '../NahratMedia';

export default function StepMedia({ step, isDark, onReload }) {
    const [pickerOpen, setPickerOpen] = useState(false);

    const secondaryColor = isDark ? 'rgba(255,255,255,0.5)' : 'var(--text-secondary)';
    const mutedColor = isDark ? 'rgba(255,255,255,0.3)' : 'var(--text-muted)';
    const borderColor = isDark ? 'rgba(255,255,255,0.08)' : 'var(--border-default)';

    const mediaList = step.media || [];

    const pridejMedium = async (souborId, prenacti = true) => {
        try {
            await apiCall(`/api/recepty/sop/kroky/${step.id}/media`, 'POST', { soubor_id: souborId });
            setPickerOpen(false);
            if (prenacti) onReload();
        } catch {
            window.dispatchEvent(new CustomEvent('in-app-toast', {
                detail: { id: crypto.randomUUID(), title: 'Chyba', body: 'Nepodařilo se přidat médium.' },
            }));
        }
    };

    const handleDeleteMedia = async (mediaId) => {
        try {
            await apiCall(`/api/recepty/sop/kroky/media/${mediaId}`, 'DELETE');
            onReload();
        } catch {}
    };

    const getThumbnailUrl = (media) => {
        const soubor = media.soubor;
        if (!soubor) return null;
        if (soubor.thumbnail_url) return soubor.thumbnail_url;
        if (soubor.url) return soubor.url;
        if (soubor.cesta) return `/storage/${soubor.cesta}`;
        return null;
    };

    return (
        <div>
            <div className="grid gap-3" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(72px, 1fr))' }}>
                {mediaList.map(m => {
                    const url = getThumbnailUrl(m);
                    return (
                        <div key={m.id} className="relative group" style={{ width: 72 }}>
                            <div className="rounded-lg overflow-hidden" style={{
                                width: 72, height: 72,
                                background: isDark ? 'rgba(255,255,255,0.06)' : 'var(--surface-base)',
                                border: `1px solid ${borderColor}`,
                            }}>
                                {url ? (
                                    <img src={url} alt={m.popis || ''} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                ) : (
                                    <div className="flex items-center justify-center h-full text-[10px]" style={{ color: mutedColor }}>?</div>
                                )}
                            </div>
                            {/* Delete button on hover */}
                            <button onClick={() => handleDeleteMedia(m.id)}
                                className="absolute -top-1 -right-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                                style={{
                                    width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    background: '#EF4444', color: '#fff', border: 'none', cursor: 'pointer',
                                }}>
                                <Trash2 size={10} />
                            </button>
                            {m.popis && (
                                <div className="text-[10px] mt-0.5 truncate text-center" style={{ color: mutedColor }}>{m.popis}</div>
                            )}
                        </div>
                    );
                })}

                {/* Nahrání z počítače — hlavní cesta, knihovna je odkaz pod mřížkou */}
                <NahratMedia varianta="dlazdice" isDark={isDark} accept="image/*,video/*" multiple
                    accent="#EF9F27"
                    onNahrano={async (_prvni, vsechny) => {
                        for (const s of vsechny) { await pridejMedium(s.id, false); }
                        onReload();
                    }} />
            </div>

            <button onClick={() => setPickerOpen(true)}
                className="flex items-center gap-1.5 mt-2 text-[11px]"
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: secondaryColor, padding: 0 }}>
                <ImageIcon size={12} /> Vybrat z knihovny
            </button>

            {mediaList.length === 0 && (
                <div className="text-center py-4 text-xs" style={{ color: mutedColor }}>
                    Zatím žádná média.
                </div>
            )}

            {/* Knihovna — `open` je povinný prop, bez něj se modal jen tiše nevykreslil.
                onSelect vrací (id, soubor), ne samotný objekt. */}
            <MediaPickerModal
                open={pickerOpen}
                accept="image/*"
                onSelect={(souborId) => pridejMedium(souborId)}
                onClose={() => setPickerOpen(false)}
            />
        </div>
    );
}
